import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// mainタグにp-topクラスが付いているかを確認
const mainElement = document.querySelector("main.p-top");

if (mainElement) {
  $(document).ready(function () {
    // Slickスライダーの初期化
    $(".main-slider").slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 8000, // スライドの表示時間を8秒
      speed: 2000,
      dots: false,
      lazyLoad: "progressive",
      arrows: false,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    });
    // 初期化時に最初のスライドにjs-slide-end-delayクラスを追加（videoは除外）
    const firstSlide = $(".main-slider .slick-current");
    if (!firstSlide.find("video").length) {
      firstSlide.addClass("js-slide-end-delay");
    }
    // スライド切り替え前にjs-slide-end-delay削除のタイミングを調整
    $(".main-slider").on("beforeChange", function (event, slick, currentSlide) {
      const currentSlideElement = $(slick.$slides[currentSlide]);
      // slick-currentが削除された3秒後にjs-slide-end-delayクラスを削除
      setTimeout(() => {
        currentSlideElement.removeClass("js-slide-end-delay");
      }, 3000);
    });
    // スライド切り替え後にjs-slide-end-delayを追加（videoは除外）
    $(".main-slider").on("afterChange", function (event, slick, currentSlide) {
      const currentSlideElement = $(slick.$slides[currentSlide]);
      // js-slide-end-delayクラスを付与（videoが含まれていない場合のみ）
      if (!currentSlideElement.find("video").length) {
        currentSlideElement.addClass("js-slide-end-delay");
      }
      // アクティブなスライドの動画を再生
      const video = currentSlideElement.find("video").get(0);
      if (video) {
        video.currentTime = 0;
        video.play();
      }
      // 非アクティブなスライドの動画を停止
      $(".main-slider li:not(.slick-active)")
        .find("video")
        .each(function () {
          const inactiveVideo = $(this).get(0);
          if (inactiveVideo) {
            inactiveVideo.pause();
            inactiveVideo.currentTime = 0;
          }
        });
    });
  });
}
